/** @module csi/configurationUtil */
define([
    "csi/configuration",
    "csi/locale"
], function(configuration,locale) {

    return {
        /**
         * Get the current status and return false if configuration is already being updated
         * @param {Controller} ac csi/action/Controller
         * @return Promise for result
         */
        preActionUpdateConfiguration: function(ac) {
            return configuration.refreshStatus().then(function() {

                if (!configuration.canUpdateStatus()) {
                    // do not do anything, just alert the user
                    ac.displayErrorDialog({
                        message: locale.resource("UpdateConfiguration_Running"),
                        onResponse: function() {}
                    });
                    return false;
                }

                return true;
            });
        }

    };
});
